import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPage implements OnInit {

  constructor(private _location:Location,
  		private _titleService:Title) { }

  ngOnInit() {
  	this._titleService.setTitle("Error");

  }

  btnBack(){
  	this._location.back();
  }


}
